<template>
  <div class="RoleApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div style="height:15px;"></div>
    <div class="scenicList">
      <img class="fmt" :src="baseUrl+setDetail.img" />
      <div class="con">
        <h2>{{setDetail.title}}</h2>
        <p>营业时间：{{setDetail.business}}</p>
        <p>近期浏览：{{setDetail.read_num}}次</p>
      </div>
      <div class="level">景区等级：<font>{{setDetail.level}}</font>
        <a @click="toPush(setDetail.id,'ticketadd')">新增门票</a>
      </div>
    </div>

    <ul>
      <li v-for="(item,i) in arr">
        <img src="~assets/images/mp.png" />
        <div class="user">
          <h2>{{item.title}}<span>{{item.createtime}}</span></h2>
          <p>有效期：{{item.starttime}} 至 {{item.endtime}}</p>
          <p>票价：<span>￥{{item.rate}}</span>  <font>￥{{item.price}}</font></p>
          <a @click="delCard(item.id)">删除</a>
        </div>
      </li>
    </ul>

    
    <div style="height:15px;"></div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        userData:[],
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        setDetail:[],
        arr:[]
      };
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
      this.getDetail();
      this.getDmp();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },
      getDetail:function(e){
        var that = this;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/index/spot',
          params:{
            id:id
          }
        }).then(function(response){
          var res = response.data.data;
          that.setDetail = res;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
      getDmp:function(e){
        var that = this;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/index/dmp',
          params:{
            id:id
          }
        }).then(function(response){
          var res = response.data;
          that.arr = res.data;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },

      delCard:function(id){
        var that = this;
        that.fullscreenLoading = true;
        this.axios({
          method:'post',
          url:that.$host+'home/index/delCard',
          params:{
            id:id
          }
        }).then(function(response){
          var res = response.data;
          if(res.status == 200){
            that.getDmp()
          }else{
            alert(res.message);
          }
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .RoleApp{
    max-width:640px;
    background:#ececec;
    margin:0 auto;
  }

  .RoleApp .scenicList{
    width:92%;
    margin:0 auto;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.01);
    background:#fff;
    border-radius:4px
  }
  .RoleApp .scenicList img{
    float:left;
    width:35%;
    margin:10px;
    border-radius:4px
  }
  .RoleApp .scenicList .con{
    float:left;
    width:55%;
    margin-top:10px;
  }
  .RoleApp .scenicList .con h2{
    font-size:15px;
    color:#333;
    letter-spacing: 1px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .RoleApp .scenicList .con p{
    font-size:14px;
    color:#666;
    margin-top:13px;
  }
  .RoleApp .scenicList .level{
    clear:both;
    width:92%;
    margin:0 auto;
    font-size:15px;
    border-top:1px #fafafa solid;
    padding:10px 0 15px 0;
    color:#666
  }
  .RoleApp .scenicList .level font{
    color:#f00;
    font-weight:bold;
  }
  .RoleApp .scenicList .level a{
    float:right;
    background:#2F78FF;
    color:#fff;
    font-size:14px;
    border-radius:4px;
    padding:5px 8px;
    margin-top:-3px
  }
  .RoleApp ul{
    width:92%;
    margin:0 auto;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.01);
    background:#fff;
    border-radius:4px;
    margin-top:15px;
  }
  .RoleApp ul li:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .RoleApp ul li{
    width:92%;
    margin:0 auto;
    padding:15px 0;
    border-bottom:solid 1px #EBF2FF
  }
  .RoleApp ul li:last-child{
    border:none;
  }
  .RoleApp ul li img{
    width:70px;
    border-radius:50%;
    float:left;
  }
  .RoleApp ul li .user{
    float:left;
    width:75%;
    margin-left:10px
  }
  .RoleApp ul li .user h2{
    font-size:15px;
    color:#333
  }
  .RoleApp ul li .user h2 span{
    float:right;
    font-size:14px;
    color:#666;
    font-weight:500;
  }
  .RoleApp ul li .user p{
    font-size:13px;
    color:#666;
    padding-top:7px
  }

  .RoleApp ul li .user p span{
      color:#f00;
      font-weight:bold;
  }
  .RoleApp ul li .user p font{
      text-decoration: line-through;
      padding-left:10px;
  }

  .RoleApp ul li .user a{
    background:#f00;
    float:right;
    color:#fff;
    font-size:15px;
    border-radius:5px;
    padding:4px 10px;
  }

</style>